import { queryOptions } from '@tanstack/react-query';

import type { Tables } from '@archetelos/db';

import { supabase } from '@/lib/supabase';

export type Subscription = Tables<'subscriptions'>;

export const subscriptionQueries = {
  current: (userId: string | undefined) =>
    queryOptions({
      queryKey: ['subscription', 'current', userId] as const,
      queryFn: async (): Promise<Subscription | null> => {
        if (!userId) return null;
        const { data, error } = await supabase
          .from('subscriptions')
          .select('*')
          .eq('user_id', userId)
          .order('created_at', { ascending: false })
          .limit(1)
          .maybeSingle();
        if (error) throw error;
        return data as Subscription | null;
      },
      enabled: Boolean(userId),
      staleTime: 1000 * 10,
    }),
};
